import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const getCategories = () => api.get("/categories").then((r) => r.data);
export const getProducts = (params) => api.get("/products", { params }).then((r) => r.data);
export const getProduct = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const postInquiry = (data) => api.post("/inquiries", data).then((r) => r.data);
export const postNewsletter = (email) => api.post("/newsletter", { email }).then((r) => r.data);
